import FundDetailsPage from "domains/liquidity/pages/FundDetailsPage/FundDetailsPage";

export default FundDetailsPage;
